import MUIAccordionDetails, { AccordionDetailsProps } from "@mui/material/AccordionDetails";
import React, { FC } from "react";

export const AccordionDetails: FC<AccordionDetailsProps> = (props) => <MUIAccordionDetails {...(props as any)} />;
